module.exports = __webpack_public_path__ + "static/gallery15-57e4f9d9294ac74e974adbe33ab02436.jpg";